import React from "react";
import { SingleSelect } from "../SingleSelect";
import "./style.scss";
/**
 * SingleSelectColor:
 *  - Alternate color varient of SingleSelect
 */
export function SingleSelectColor(props) {
  return (
    <SingleSelect
      id={props.id}
      image={props.image}
      content={props.content}
      options={props.options}
      question={props.question}
      answerId={props.answerId}
      complete={props.complete}
      hintDetails={props.hintDetails}
      contentList={props.contentList}
      selectOption={props.selectOption}
      submitAnswer={props.submitAnswer}
      sliderGroups={props.sliderGroups}
      totalAttempts={props.totalAttempts}
      className={`cscqColor ${props.className}`}
    />
  );
}

SingleSelectColor.propTypes = SingleSelect.propTypes;

SingleSelectColor.defaultProps = {
  ...SingleSelect.defaultProps,
  className: "",
};
